export function Popup({ title, closePopup, popupData, handleRefresh, children }) {
    return (
        <div className="popup z-50 flex">
            <div className="popup-all min-w-max border-2 border-gray-100 shadow-lg bg-gray-50">
                <div className="popup-header">
                    <div className="flex flex-row justify-between max-h-9 px-1">
                        <h2 className="font-bold text-2xl">{title}</h2>
                        <button className="popup-close text-center font-semibold text-xl my-5  py-3 w-14 self-end uppercase rounded-3xl text-gray-450 hover:opacity-90 transition-all" onClick={closePopup}>X</button>
                    </div>
                    <div className="px-2"><hr /></div>
                </div>
                <div className="popup-inner my-5 scrollbar">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Popup